import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    console.log("Scrolling to top across all z-indexes", pathname)

    // Scroll the main window
    window.scrollTo(0, 0)

    // Find and scroll all scrollable elements
    const scrollToTopAllElements = () => {
      // Get all elements that might be scrollable
      const allElements = document.querySelectorAll("*")

      allElements.forEach((element) => {
        const el = element as HTMLElement

        // Check if element is scrollable
        const hasVerticalScrollbar = el.scrollHeight > el.clientHeight
        const hasHorizontalScrollbar = el.scrollWidth > el.clientWidth

        // Check if element has overflow scroll/auto
        const computedStyle = window.getComputedStyle(el)
        const overflowY = computedStyle.overflowY
        const overflowX = computedStyle.overflowX

        const isScrollableY = (overflowY === "scroll" || overflowY === "auto") && hasVerticalScrollbar
        const isScrollableX = (overflowX === "scroll" || overflowX === "auto") && hasHorizontalScrollbar

        // Scroll to top if scrollable
        if (isScrollableY || isScrollableX) {
          el.scrollTo(0, 0)
        }
      })

      // Also handle common modal/overlay patterns
      const commonModalSelectors = [
        '[role="dialog"]',
        '[role="modal"]',
        ".modal",
        ".overlay",
        ".drawer",
        ".sidebar",
        ".popup",
        "[data-modal]",
        "[data-overlay]"
      ]

      commonModalSelectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector)
        elements.forEach((el) => {
          ;(el as HTMLElement).scrollTo(0, 0)
        })
      })
    }

    // Execute immediately
    scrollToTopAllElements()

    // Also execute after a small delay to catch any elements that might be rendered async
    setTimeout(scrollToTopAllElements, 100)
  }, [pathname])

  return null
}
